module.exports = __webpack_public_path__ + "static/media/18ECA45.938e3aad.jpg";